/* import __COLOCATED_TEMPLATE__ from './submitting-kyb.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();